export default __webpack_public_path__ + "static/media/editPen.60c36b7a.webp";